<div
  *ngIf="
    (analysis?.result || showNoResult) &&
    !report &&
    !microbiome &&
    type !== AnalysesTypesLowercase.PhysicalTraits
  "
  (click)="onClick()"
  class="analysis-link white-section card-shadow-1 hover-shadow active-transparent d-flex align-items-center gpl-16 gpr-4 gpr-md-16 gpy-12 pointer"
>
  <div class="me-auto overflow-hidden w-100 position-relative">
    <div
      class="rt1-regular text-fade"
      [innerHTML]="analysis?.shortName || analysis?.name || analysis?.longName"
    ></div>
    <div
      *ngIf="analysis?.longName && type === AnalysesTypesLowercase.Blood"
      class="rl2-regular text-fade text-muted gmt-md-2"
      [innerHTML]="analysis?.longName"
    ></div>
    <div class="d-flex flex-row justify-content-start align-items-end">
      <span
        *ngIf="hasResult; else noResultText"
        class="rs1-regular gmt-md-2 gmr-8 text-truncate"
        [style.color]="
          (analysis?.semanticType | colorize) ||
          (analysis?.result['semanticType'] | colorize) ||
          (analysis?.type | colorize) ||
          (analysis?.levelType | colorize) ||
          analysis?.color ||
          '#A3A3B2'
        "
        [innerHTML]="resultLabel | transformUnits"
      >
      </span>
      <span
        *ngIf="analysis?.isNew"
        class="d-inline-block l2-semibold gp-tag gp-tag-red new-analysis text-nowrap"
      >
        {{ 'ANALYSES.NEW.LABEL' | translate }}
      </span>
    </div>

    <div
      class="d-flex align-items-center gmt-md-2"
      *ngIf="analysis?.result?.generated"
    >
      <span class="rl2-regular text-muted gmr-12">
        {{ analysis?.result?.generated | timeAgo }}
      </span>
      <span
        class="d-block l2-semibold gp-tag gp-tag-red"
        *ngIf="reCheckLabel && displayReCheck(analysis?.result?.generated)"
      >
        {{ 'RESULTS.BLOOD.RE_CHECK.LABEL' | translate }}
      </span>
    </div>
    <ng-template #noResultText>
      <span class="d-block gmt-4 l2-semibold gp-tag">
        {{
          (type === AnalysesTypesLowercase.DNA
            ? 'ANALYSES.UNLOCK'
            : 'ANALYSES.MISSING_RESULT'
          ) | translate
        }}
      </span>
    </ng-template>
  </div>

  <div
    class="d-flex align-items-center text-end ms-2"
    *ngIf="hasResult; else noResultIcon"
  >
    <i
      *ngIf="
        (analysis?.type ||
          analysis?.semanticType ||
          analysis?.result['semanticType']) &&
        !hideCircles
      "
      class="gpicon-circle gpicon-sm"
      [style.color]="
        (analysis?.result['semanticType'] | colorize) ||
        (analysis?.semanticType | colorize) ||
        (analysis?.type | colorize) ||
        (analysis?.levelType | colorize) ||
        analysis?.color ||
        '#A3A3B2'
      "
    ></i>
    <i class="gpicon-forward gpicon-lg text-gray gml-12"></i>
  </div>
  <ng-template #noResultIcon>
    <div class="d-flex align-items-center justify-content-end ms-2 me-1">
      <ng-container *ngIf="analysis.analysisId !== AnalysisId.stepsId">
        <i
          *ngIf="type === AnalysesTypesLowercase.DNA"
          class="gpicon-add-locked gpicon-lg text-gray"
        ></i>
        <i
          *ngIf="analysis?.type !== AnalysesTypesLowercase.DNA"
          class="gbtn-1 gp-16 gpicon-add-plus text-primary"
        ></i>
      </ng-container>
      <i class="gpicon-forward gpicon-lg text-gray m-0"></i>
    </div>
  </ng-template>
</div>

<div
  *ngIf="report"
  class="analysis-link white-section card-shadow-1 hover-shadow active-transparent d-flex gpy-12 gpl-12 gpr-16 pointer"
  (click)="onClick()"
>
  <div
    class="me-auto overflow-hidden w-100 position-relative d-flex justify-content-between align-items-center"
  >
    <div class="d-flex align-items-center w-100 text-fade">
      <img [src]="report?.image" class="d-inline-block" style="width: 54px" />
      <div class="d-flex flex-column w-100 gml-12">
        <p
          class="gmb-0"
          [ngClass]="'rt1-regular' | gpuMediaQuery: 'rt2-regular'"
          [innerHTML]="
            type === AnalysesTypesLowercase.Blood ? report?.name : report?.title
          "
        ></p>
        <p
          *ngIf="
            [AnalysesTypes.NIPT, AnalysesTypes.Blood].includes(report?.type)
          "
          class="rl2-regular text-secondary gmt-4 gmt-2 gmb-0"
        >
          {{ report?.generated | localDate }}
        </p>
      </div>
    </div>
    <i class="gpicon-forward gpicon-lg text-gray m-0"></i>
  </div>
</div>

<div
  *ngIf="microbiome"
  (click)="onClick()"
  class="analysis-link white-section card-shadow-1 hover-shadow active-transparent d-flex gpy-12 gpx-16 pointer"
>
  <div class="me-auto overflow-hidden w-100 position-relative">
    <div class="rt1-regular text-fade" [innerHTML]="microbiome?.name"></div>
    <span
      class="d-block rs1-regular text-fade text-muted"
      [ngClass]="
        microbiome.semanticType === SemanticTypes.UNFAVOURABLE
          ? 'text-danger'
          : 'text-muted'
      "
    >
      {{
        'ORAL_MICROBIOME.ASSOCIATED.' +
          (microbiome.semanticType === SemanticTypes.UNFAVOURABLE
            ? 'RELEVANT_MICROBES'
            : 'NO_RELEVANT_MICROBES') | translate
      }}
    </span>
  </div>

  <div class="d-flex align-items-center text-end ms-2">
    <i
      *ngIf="microbiome?.semanticType && !hideCircles"
      class="gpicon-circle gpicon-sm"
      [style.color]="
        microbiome.semanticType === SemanticTypes.UNFAVOURABLE
          ? (microbiome.semanticType | colorize)
          : '#9599AA'
      "
    ></i>
    <i class="gpicon-forward gpicon-lg text-gray gml-12"></i>
  </div>
</div>

<a *ngIf="type === AnalysesTypesLowercase.PhysicalTraits" (click)="onClick()">
  <div
    class="analysis-link white-section card-shadow-1 hover-shadow active-transparent d-flex gpy-12 gpx-16 pointer"
  >
    <div class="me-auto overflow-hidden w-100 position-relative">
      <div
        class="rt1-regular text-fade"
        [innerHTML]="
          analysis?.shortName || analysis?.name || analysis?.longName
        "
      ></div>
      <div class="d-flex flex-row justify-content-start align-items-end">
        <span
          class="d-inline-block gmt-2 gmr-8 rs1-regular subtitle text-truncate"
          *ngIf="analysis?.result"
        >
          {{ analysis?.result }}
        </span>

        <span
          *ngIf="analysis?.isNew"
          class="d-inline-block l2-semibold gp-tag gp-tag-red new-analysis text-nowrap"
        >
          {{ 'ANALYSES.NEW.LABEL' | translate }}
        </span>
      </div>
    </div>
    <div class="d-flex align-items-center text-end ms-2">
      <i class="gpicon-forward gpicon-lg text-gray gml-12"></i>
    </div>
  </div>
</a>
